import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=05bbbfe8&scoped=true&"
import script from "./UserChip.vue?vue&type=script&lang=ts&"
export * from "./UserChip.vue?vue&type=script&lang=ts&"
import style0 from "./UserChip.vue?vue&type=style&index=0&id=05bbbfe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbbfe8",
  null
  
)

export default component.exports